function OnboardingSidebarMenuItemCtrl($scope, $timeout, organizationService, onboardingService) {
  const currentUserOrganization = organizationService.getCurrentOrganization();

  $scope.onboardingCompleteOnPageLoad = onboardingService.isCurrentOrganizationOnboardingComplete();

  $scope.organization = currentUserOrganization;

  $scope.onboardingComplete = function () {
    return onboardingService.isCurrentOrganizationOnboardingComplete();
  };

  $scope.stepsRemaining = function () {
    return onboardingService.getCurrentOrganizationStepsRemaining();
  };

  if ($scope.onboardingComplete) {
    $scope.$watch(() => {
      return onboardingService.getCurrentOrganizationStepsRemaining();
    }, () => {
      $scope.stepsUpdated = true;

      $timeout(() => {
        $scope.stepsUpdated = false;
      }, 1000);
    });
  }
}

OnboardingSidebarMenuItemCtrl.$inject = [
  '$scope',
  '$timeout',
  'organizationService',
  'onboardingService'
];

export default OnboardingSidebarMenuItemCtrl;



// WEBPACK FOOTER //
// ./src/directives/onboardingSidebarMenuItem/controller.js